import Avatar from '../../../components/Avatar/Avatar'

function PatientShiftStack({ people }) {
  const list = Array.isArray(people) ? people : []
  if (!list.length) return null
  const visible = list.slice(0, 5)
  const names = list.map((user) => user.name).filter(Boolean).join(', ')

  return (
    <div className="patients-access-stack patients-shift-stack" title={names ? `Em plantão: ${names}` : 'Em plantão'}>
      {visible.map((user) => (
        <Avatar
          key={user.id}
          name={user.name}
          email={user.email}
          imageUrl={user.avatar_url}
          size="sm"
        />
      ))}
      {list.length > 5 && (
        <span className="patients-access-more">+{list.length - 5}</span>
      )}
    </div>
  )
}

export default PatientShiftStack
